document.querySelector(".close-btn").addEventListener('click', function() {
    document.querySelector(".custom-model-main").classList.remove('model-open');
  });
  document.querySelector(".bg-overlay").addEventListener('click', function() {
    document.querySelector(".custom-model-main").classList.remove('model-open');
  });
  document.querySelector(".product_invoice .close-btn").addEventListener('click', function() {
    document.querySelector(".product_invoice.custom-model-main").classList.remove('model-open');
  });
  document.querySelector(".product_invoice .bg-overlay").addEventListener('click', function() {
    document.querySelector(".product_invoice.custom-model-main").classList.remove('model-open');
  });
  function goDoSomething(d){
      $(".get_information").empty();
      var handle = d.getAttribute("data-handle");
      get_product_data(handle);
      document.querySelector('.product_invoice').classList.add('model-open');
  }
  function get_product_data(handle){
      $(".popup_loader").show();
      const xhttp = new XMLHttpRequest();
      xhttp.onload = function() {
          var t = this.responseText;
          t = $.parseHTML(t),
          console.log($(t).find('body'));
          document.querySelector(".get_information").innerHTML = this.responseText;
          $(".get_information .downloadbtn_pdp").insertBefore(".get_information .product-info__vendor.redtext.plexfont");
          $(".product-info__accordion").insertAfter(".hide_mobile_tattoo");
          $(".supported_software").insertBefore(".product-info__variant-picker");
          $(".supported_software li:eq(0)").before("<li>Compatible with: </li>");
          $(".get_information .style_accordion").insertAfter(".supported_software");
          $(".get_information .style_accordion").attr('open',true);
          var style_content = $(".get_information .style_accordion[open='open']").find(".accordion__content").html();
          var text = '<div class="accordian_title">Styles: </div>';
          $(".get_information .style_accordion[open='open'] .accordion__content").html(text+style_content);
  
          var files_content = '';
  
          $(".files_desc").each(function(){
              if($(this).data('handle') == handle){
                  files_content = $(this);
              }
          });
  
          $(files_content).insertAfter(".product-info__accordion.style_accordion");
  
          $(".popup_loader").hide();
      }
      var url = 'https://tattoosmart.com/products/'+handle;
      xhttp.open("GET", url);
      xhttp.send();
  }